//store index.js
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
//初始化时用sessionStore.getItem('token'),这样子刷新页面就无需重新登录
const state = {
    token: window.sessionStorage.getItem('token'),
    userid: window.sessionStorage.getItem('userid')
};
const mutations = {
    SETTOKEN: (state, data) => {
        //更改token的值
        state.token = data;
        window.sessionStorage.setItem('token', data);
    },
    LOGOUT: (state) => {
        //登出的时候要清除token
        state.token = null;
        state.userid = null;
        window.sessionStorage.removeItem('token');
        window.sessionStorage.removeItem('userid');
    },
    SETSTATUSHEIGHT: (state, data) => {
        // 存储状态栏高度
        state.statusheight = data;
    },
    SETUSERID: (state, data) => {
        //把用户id存起来
        state.userid = data;
        window.sessionStorage.setItem('userid', data);
    }
};
const actions = {
    SetToken({ commit }, data){
        commit('SETTOKEN', data);
    },
    UserLogout({ commit }){
        commit('LOGOUT');
    },
    SetStatusHeight({ commit }, data){
        commit('SETSTATUSHEIGHT', data);
    },
    SetUserId({ commit }, data){
        commit('SETUSERID', data);
    }
};
export default new Vuex.Store({
    state,
    mutations,
    actions
});
